import React from 'react';

import { useEffect, useState } from 'react';

import { useNavigate, Link } from 'react-router-dom';

import { Container, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Table } from 'react-bootstrap';

import { Button } from 'react-bootstrap';

import SchoolTypeStore from '../../../stores/SchoolTypeStore';

const SchoolTypeListPage = ({ users }) => {
    const navigate = useNavigate();

    const store = SchoolTypeStore((state) => state);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(9);
    const [lastPage, setLastPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);

    useEffect(() => {
        const success = (res) => {
            setLastPage(res.lastPage);
            setTotalResults(res.totalResults);
        };
        store.loadAll(pageSize, currentPage, success);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    const handlePageChange = (page) => {
        // change page on click
        if (page >= 1 && page <= lastPage) {
            setCurrentPage(page);

            const success = (res) => {
                setLastPage(res.lastPage);
                setTotalResults(res.totalResults);
            };

            store.loadAll(pageSize, page, success);
        }
    };

    const handlePageSizeChange = (size) => {
        setPageSize(Number(size.target.value));
        setCurrentPage(1);

        const success = (res) => {
            setLastPage(res.lastPage);
            setTotalResults(res.totalResults);
        };

        store.loadAll(Number(size.target.value), 1, success);
    };

    if (null != store.schoolTypes) {
        var tableRows = store.schoolTypes.map(function (schoolType, i) {
            return (
                <tr key={'user-' + i}>
                    <td>
                        <a
                            href="#"
                            onClick={() => {
                                navigate('edit/' + schoolType.id);
                            }}
                        >
                            {i + 1}
                        </a>
                    </td>
                    <td>
                        <a
                            href="#"
                            onClick={() => {
                                navigate('edit/' + schoolType.id);
                            }}
                        >
                            {schoolType.id}
                        </a>
                    </td>
                    <td>
                        <div
                            onClick={() => {
                                navigate('edit/' + schoolType.id);
                            }}
                        >
                            {schoolType.name}
                        </div>
                    </td>
                </tr>
            );
        });
    }

    const renderPagination = () => {
        const pages = [];
        const maxPagesToShow = 5; // Number of pages to show in the middle
        const startPage = Math.max(2, currentPage - 2); // Start from the second page
        const endPage = Math.min(lastPage - 1, currentPage + 2); // End at the second-to-last page

        // Add the first page button
        pages.push(
            <a
                key={1}
                href="#"
                className={`page-link ${currentPage === 1 ? 'active' : ''}`}
                onClick={() => handlePageChange(1)}
            >
                1
            </a>,
        );

        // Add ellipsis if starting page is greater than 2
        if (startPage > 2) {
            pages.push(
                <span key="start-ellipsis" className="page-ellipsis">
                    ...
                </span>,
            );
        }

        // Add the pages in the range (two before current page to two after)
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <a
                    key={i}
                    href="#"
                    className={`page-link ${i === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </a>,
            );
        }

        // Add ellipsis if ending page is less than lastPage - 1
        if (endPage < lastPage - 1) {
            pages.push(
                <span key="end-ellipsis" className="page-ellipsis">
                    ...
                </span>,
            );
        }

        // Add the last page button if there are more than one page
        if (lastPage > 1) {
            pages.push(
                <a
                    key={lastPage}
                    href="#"
                    className={`page-link ${currentPage === lastPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(lastPage)}
                >
                    {lastPage}
                </a>,
            );
        }

        return (
            <div className="pagination" id="pagination">
                <a
                    href="#"
                    id="prev"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </a>
                {pages}
                <a
                    href="#"
                    id="next"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === lastPage}
                >
                    Next
                </a>
            </div>
        );
    };

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('create');
                        }}
                    >
                        Create SchoolType
                    </Button>
                </Col>
            </Row>
            <br />
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <FormGroup
                        controlId={'Search-text-input'}
                        style={{ marginBottom: '18px' }}
                    >
                        <FormLabel>Filter</FormLabel>
                        <FormControl type="text" onChange={(e) => {}} />
                    </FormGroup>

                    <Table striped bordered condensed="true" hover>
                        <thead>
                            <tr>
                                <th>Number</th>
                                <th>SchoolType ID</th>
                                <th>SchoolType Name</th>
                            </tr>
                        </thead>

                        <tbody>{tableRows}</tbody>
                    </Table>
                    {renderPagination()}

                    <select
                        onChange={(size) => handlePageSizeChange(size)}
                        value={pageSize}
                    >
                        <option value={9}>9</option>
                        <option value={18}>18</option>
                        <option value={32}>32</option>
                    </select>
                    <div style={{ margin: '10px 0' }}>
                        Found {totalResults} results
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default SchoolTypeListPage;
